import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import ADMIN_API_URL from "../../../config/AdminApiUrl";

export const getTenantEmailConfigurationList = createAsyncThunk(
  "TenantEmailConfiguration/get",
  async (tenantId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${ADMIN_API_URL.EMAIL_CONFIGURATION.SLUG}/${tenantId}/Configurations`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createTenantEmailConfiguration = createAsyncThunk(
  "TenantEmailConfiguration/create",
  async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data } = await axios.post(
        `${ADMIN_API_URL.EMAIL_CONFIGURATION.SLUG}`,
        payload
      );
      dispatch(getTenantEmailConfigurationList(payload.tenantId));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const editTenantEmailConfiguration = createAsyncThunk(
  "TenantEmailConfiguration/put",
  async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data } = await axios.put(
        `${ADMIN_API_URL.EMAIL_CONFIGURATION.SLUG}/${payload.id}`,
        payload
      );
      dispatch(getTenantEmailConfigurationList(payload.tenantId));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const deleteTenantEmailConfiguration = createAsyncThunk(
  "TenantEmailConfiguration/delete",
  async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data } = await axios.delete(
        `${ADMIN_API_URL.EMAIL_CONFIGURATION.SLUG}/${payload.id}/${payload.tenantId}`
      );
      dispatch(getTenantEmailConfigurationList(payload.tenantId));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const makeConfigurationDefault = createAsyncThunk(
  "TenantEmailConfiguration/create",
  async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data } = await axios.put(
        `${ADMIN_API_URL.EMAIL_CONFIGURATION.SLUG}/${payload.id}/${payload.tenantId}/set-default`
      );
      dispatch(getTenantEmailConfigurationList(payload.tenantId));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

const emailConfigurationSlice = createSlice({
  name: "emailConfiguration",
  initialState: {
    current_values: null,
    email_configuration_list: [],
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getTenantEmailConfigurationList.fulfilled,
      (state, action) => {
        state.email_configuration_list = action.payload;
      }
    );
  },
});

export const { setCurrentValues, setActivePayload, resetCurrentValue } =
  emailConfigurationSlice.actions;
export default emailConfigurationSlice.reducer;
